import type { FC } from "react";

import { TextSwitcherItem } from "@similarweb/ui-components";

import type { TabFilter } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { TabFilterNaming } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { allTrackers } from "app/services/track/track";

import { FILTERS } from "./consts";
import { FiltersSwitcher } from "./TableFilters.styled";

interface ITableFiltersProps {
    tabIndex: TabFilter;
    onSwitch: (tabIndex: TabFilter) => void;
}

export const TableFilters: FC<ITableFiltersProps> = ({ tabIndex, onSwitch }) => {
    const handleSwitchItemChange = (itemIndex: TabFilter): void => {
        allTrackers.dispatchTrackEvent("Tab", "click", `Change page tab/${TabFilterNaming[itemIndex]}`);
        onSwitch(itemIndex);
    };

    return (
        <div id="ai-tracker-switch-wrapper">
            <FiltersSwitcher
                selectedIndex={tabIndex}
                onItemClick={handleSwitchItemChange}
            >
                {FILTERS.map(({ key, text }) => (
                    <TextSwitcherItem
                        key={key}
                        data-automation-button-name={`ai-tracker-${key}`}
                    >
                        {text}
                    </TextSwitcherItem>
                ))}
            </FiltersSwitcher>
        </div>
    );
};
